module.exports = __webpack_public_path__ + "media/images/activecampaign-b7b9ba2ddcf5c058d9ee6d67335f4d2b.svg";